import { Injectable, NgZone } from '@angular/core';
import { User } from "../services/user";
// import { auth } from 'firebase/compat/app';
import { AngularFireAuth } from "@angular/fire/compat/auth";
import { AngularFirestore, AngularFirestoreDocument } from '@angular/fire/compat/firestore';
import { Router } from "@angular/router";
import { first } from 'rxjs/operators';
import { JwtHelperService } from "@auth0/angular-jwt";

import { GoogleAuthProvider, getAuth, updateEmail } from 'firebase/auth';
@Injectable({
  providedIn: 'root'
})

export class AuthService {
  userData: any; // Save logged in user data

  constructor(
    public afs: AngularFirestore,   // Inject Firestore service
    public afAuth: AngularFireAuth, // Inject Firebase auth service
    public router: Router,
    public ngZone: NgZone // NgZone service to remove outside scope warning
  ) {
    /* Saving user data in localstorage when
    logged in and setting up null when logged out */
    this.afAuth.authState.subscribe(user => {


      if (user) {
        this.userData = user;
        localStorage.setItem('user', JSON.stringify(this.userData));
        JSON.parse(localStorage.getItem('user'));
      } else {
        localStorage.setItem('user', null);
        JSON.parse(localStorage.getItem('user'));
      }
    })
  }

  resetPassword(email) {
    return this.afAuth.sendPasswordResetEmail(email);
  }

  refreshToken() {
    return this.afAuth.currentUser.then((d) => {
      return d.getIdToken().then((token) => {
        // console.log(d)
        localStorage.setItem("token", token);
        return token
      })
    })
  }

  getToken() {
    const helper = new JwtHelperService();
    const token = localStorage.getItem('token');
    const isExpired = helper.isTokenExpired(token);
    return new Promise((resolve, reject) => {
      if (isExpired) {
        console.log('Update token')
        this.refreshToken().then((token) => {
          // console.log(d)
          return token;
          resolve(token)
        }, err => reject(err))
      } else {
        resolve(token)
        return token
      }
    })
  }

  // Sign in with email/password
  SignIn(email, password) {
    return this.afAuth.signInWithEmailAndPassword(email, password)
      .then(async (result) => {
        await this.SetUserData(result.user);
        this.ngZone.run(() => {
          this.router.navigate(['dashboard/home']);
        });
      }).catch((error) => {
        window.alert(error.message)
      })
  }

  // Sign up with email/password
  SignUp(email, password) {
    return this.afAuth.createUserWithEmailAndPassword(email, password)
      .then((result) => {
        /* Call the SendVerificaitonMail() function when new user sign
        up and returns promise */
        // this.SendVerificationMail();
        this.SetUserData(result.user);
        this.router.navigate(['verify-email-address']);
      }).catch((error) => {
        window.alert(error.message)
      })
  }

  async updateProfileEmail(email){
    const auth = getAuth();
    try {
      await updateEmail(auth.currentUser, email);
      return 'Email updated successfully';
    } catch (error) {
      throw error;
    }
  }

  // Send email verfificaiton when new user sign up
  async SendVerificationMail() {
    (await this.afAuth.currentUser).sendEmailVerification().then(() => {

    });
    return this.afAuth.currentUser
      .then(() => {
        this.router.navigate(['verify-email-address']);
      })
  }

  // Reset Forggot password
  ForgotPassword(passwordResetEmail) {
    return this.afAuth.sendPasswordResetEmail(passwordResetEmail)
      .then(() => {
        window.alert('Password reset email sent, check your inbox.');
      }).catch((error) => {
        window.alert(error)
      })
  }


  // Returns true when user is looged in and email is verified
  // get isLoggedIn(): boolean {
  //   const user = JSON.parse(localStorage.getItem('user'));
  //   
  //   
  //   return (user !== null && user.emailVerified !== false) ? true : false;
  // }

  isLoggedIn() {
    return this.afAuth.authState.pipe(first()).toPromise();
  }



  // Sign in with Gmail
  GoogleAuth() {
    return this.AuthLogin(new GoogleAuthProvider());
  }

  // Auth providers
  AuthLogin(provider) {
    return this.afAuth
      .signInWithPopup(provider)
      .then(async (result) => {
        await this.SetUserData(result.user);
        this.ngZone.run(() => {
          this.router.navigate(['dashboard/home']);
        });
      })
      .catch((error) => {
        window.alert(error);
      });
  }

  /* Setting up user data when sign in with username/password,
  sign up with username/password and sign in with social auth
  provider in Firestore database using AngularFirestore + AngularFirestoreDocument service */
  SetUserData(user) {
    const userRef: AngularFirestoreDocument<any> = this.afs.doc(`users/${user.uid}`);
    const userData: User = {
      uid: user.uid,
      email: user.email,
      displayName: user.displayName,
      photoURL: user.photoURL,
      emailVerified: user.emailVerified,
    }
    return userRef.set(userData, {
      merge: true
    })
  }

  // Sign out
  SignOut() {
    return this.afAuth.signOut().then(() => {
      localStorage.removeItem('user');
      this.router.navigate(['sign-in']);
    })
  }

}
